import React from 'react';
import Home from '../../business/blog/home/async';
import Post from '../../business/blog/post/async';
import Author from '../../business/blog/author/async';
import Search from '../../business/blog/search/async';
import {Navigate, Route} from 'react-router-dom';

export default [
  <Route
    key="/consumer/blog/author/:name"
    path="consumer/blog/author/:name"
    element={<Author />}
  />,
  <Route
    key="/consumer/blog/post"
    path="consumer/blog/post"
    element={<Post />}
  />,
  <Route
    key="/consumer/blog/author"
    path="consumer/blog/author"
    element={<Author />}
  />,
  <Route
    key="/consumer/blog/search"
    path="consumer/blog/search/:keywords"
    element={<Search />}
  />,
  <Route
    key="/consumer/blog/category/:attr"
    path="consumer/blog/category/:attr"
    element={<Search />}
  />,
  <Route
    key="/consumer/blog/:category/:title"
    path="consumer/blog/:category/:title"
    element={<Post />}
  />,
  <Route
    key="/consumer/blog/:param"
    path="consumer/blog/:param"
    element={<Home />}
  />,
  <Route
    key="/consumer/blog"
    path="consumer/blog"
    element={<Navigate to="../consumer/blog/1" replace />}
  />,
];
